import { FinancialOperationCurrentBalance } from '../../__generated__/graphql';

export function selectWalletBalance(data: FinancialOperationCurrentBalance | null | undefined): number | null {
  if (!data) {
    return null;
  }
  return data.currentBalanceGbp;
}
